<template>
    <div class="products">
        <div v-if="loading" class="loading"></div>
        <div v-if="!tech">
            <div class="container">
                <div v-if="products === null"><h4>Товары не найдены</h4></div>
                <div v-if="products !== null"><h4 class="order-title">Заказ №{{ history.order_number }} от {{ history.created_at }}</h4></div>
                <table v-if="products !== null" class="table table-hover">
                    <thead class="thead">
                    <tr>
                        <td>#</td>
                        <td>Артикул</td>
                        <td>Наименование</td>
                        <td class="text-center">Цена тг</td>
                        <td class="text-center">Заказ (колич.)</td>
                        <td class="text-center">Итог</td>
                    </tr>
                    </thead>

                    <tbody class="tbody">
                    <product-def
                            v-for="(product, index) in products"
                            :product="product"
                            :key="product.id"
                            :index="index"
                    ></product-def>
                    </tbody>
                </table>

                <div class="basket-information" v-if="products !== null">
                    <div class="left">
                        <div class="user-info">
                            <div class="info-group">
                                <span class="name">ФИО:</span><span
                                    class="value">{{ this.$auth.user().name }}</span>
                            </div>

                            <div class="info-group">
                                <span class="name">Компания:</span><span
                                    class="value">{{ this.$auth.user().company }}</span>
                            </div>

                            <div class="info-group">
                                <span class="name">БИН</span><span class="value">{{ this.$auth.user().bin }}</span>
                            </div>

                            <div class="info-group">
                                <span class="name">E-mail:</span><span class="value">{{ this.$auth.user().email }}</span>
                            </div>

                            <div class="info-group">
                                <span class="name">Телефон:</span><span class="value">{{ this.$auth.user().phone }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="right">
                        <div class="info-group">
                            <span class="name">Итог:</span> <span class="value">{{ history.total_price | chunk }} тг.</span>
                        </div>
                        <div class="info-group">
                            <span class="name">Выбрано позиций: </span><span class="value">{{ history.products.length }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">Комментарии: </span><span class="value">{{ history.comment }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">Статус: </span><span class="value">{{ history.status }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-center mt-5">Техничесике неполадки. Свяжитесь с менеджером: +7 747 717 60 60</div>
        </div>
    </div>
</template>

<script>
    import ProductDef from "../order/ProductDefault";


    // const swal = require('sweetalert2');

    export default {
        data() {
            return {
                history: null,
                products: null,
                loading: false,
                tech: false
            }
        },

        mounted() {
            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'История'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.tech = true
                    }
                })



            this.loading = true;
            this.axios
                .get(this.axios.defaults.baseURL + 'histories/' + this.$route.params.order_number)
                .then(response => {
                    this.history = response.data.history;

                    this.history.status == true ? this.history.status = 'Реализован' : this.history.status = 'Не реализован'
                    this.products = this.history.products;
                })
                .catch(error => {
                    this.errored = true;
                }).finally(() => {
                this.loading = false;
            })
        },
        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        },
        components: {
            ProductDef
        }
    }
</script>

<style lang="scss">
    .basket-information {
        .left {
            .user-info {
                margin-top: 0;
                .info-group {
                    width: 100%;
                    font-size: 18px;
                    .name {
                        width: 120px;
                    }
                }
            }
        }

        .right{

        }

        .right {

            .row {
                display: flex;
                align-items: center;

                .form-group {
                    margin-bottom: 0;
                }

                .form-group-warning {
                    font-size: 12px;
                }
            }

            .form-group {
                width: 100%;

                display: flex;
                flex-direction: column;

                margin-bottom: 25px;

                label {
                    margin-bottom: 10px;

                }

                select {
                    padding: 5px 10px;
                    font-size: 16px;
                }

                textarea {
                    font-family: "Roboto-Regular";
                    resize: none;
                    padding: 10px;
                }
            }

            .form-group-warning, .form-group-error {
                font-size: 16px;
                padding: 15px;
                border-radius: 5px;

                b {
                    font-family: "Roboto-Bold";
                }

            }

            .form-group-error {
                color: #a94442;
                background-color: #f2dede;
                border-color: #ebccd1;
            }

            .form-group-warning {
                color: #8a6d3b;
                background-color: #fcf8e3;
                border-color: #faebcc;
            }

            .btn-main {
                background-color: #337ab7;
                border-color: #2e6da4;

                margin-right: 30px;
                padding: 10px 15px;
                font-size: 18px;
                border-radius: 5px;

                color: #fff;

                transition: all 350ms ease-in-out;

                &:hover {
                    background-color: #286090;
                    border-color: #204d74;
                }

                cursor: pointer;
            }
        }
    }

    .order-title{
        font-family: "Roboto-Bold";
        font-size: 24px;
        padding: 35px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/history/History.vue